/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Directdialing1Inputs */

const en_entity_directdialing1 = /** @type {(inputs: Entity_Directdialing1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direct Dialing`)
};

const de_entity_directdialing1 = /** @type {(inputs: Entity_Directdialing1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direktwahl`)
};

/**
* | output |
* | --- |
* | "Direct Dialing" |
*
* @param {Entity_Directdialing1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_directdialing1 = /** @type {((inputs?: Entity_Directdialing1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Directdialing1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_directdialing1(inputs)
	return de_entity_directdialing1(inputs)
});
export { entity_directdialing1 as "entity_directDialing" }